import { DEFAULT_LOCALE } from "@shared/constants";

import "@formatjs/intl-relativetimeformat/polyfill";
import "@formatjs/intl-relativetimeformat/locale-data/en";
import "@formatjs/intl-relativetimeformat/locale-data/de";
import "@formatjs/intl-relativetimeformat/locale-data/es";
import "@formatjs/intl-relativetimeformat/locale-data/fr";
import "@formatjs/intl-relativetimeformat/locale-data/it";
import "@formatjs/intl-relativetimeformat/locale-data/he";
import "@formatjs/intl-relativetimeformat/locale-data/tr";
import "@formatjs/intl-relativetimeformat/locale-data/pt";
import "@formatjs/intl-relativetimeformat/locale-data/zh";
import "@formatjs/intl-relativetimeformat/locale-data/uk";
import "@formatjs/intl-relativetimeformat/locale-data/vi";
import "@formatjs/intl-relativetimeformat/locale-data/sr";
import "@formatjs/intl-relativetimeformat/locale-data/hr";
import "@formatjs/intl-relativetimeformat/locale-data/pl";
import "@formatjs/intl-relativetimeformat/locale-data/cs";
import "@formatjs/intl-relativetimeformat/locale-data/sq";
import "@formatjs/intl-relativetimeformat/locale-data/el";
import "@formatjs/intl-relativetimeformat/locale-data/ar";

const ar = require("@shared/translations/ar.json");
const el = require("@shared/translations/el.json");
const ro = require("@shared/translations/ro.json");

const loadTranslation = (lang) => {
  return Object.assign(
    require(`@shared/translations/${lang}.json`),
    require(`@theme/translations/${lang}.json`)
  );
};

const translation = {
  en: loadTranslation("en"),
  de: loadTranslation("de"),
  es: loadTranslation("es"),
  fr: loadTranslation("fr"),
  it: loadTranslation("it"),
  he: loadTranslation("he"),
  tr: loadTranslation("tr"),
  pt: loadTranslation("pt"),
  zh: loadTranslation("zh"),
  uk: loadTranslation("uk"),
  //
  vi: loadTranslation("vi"),
  sr: loadTranslation("sr"),
  hr: loadTranslation("hr"),
  pl: loadTranslation("pl"),
  cs: loadTranslation("cs"),
  sq: loadTranslation("sq"),
  el,
  ru: loadTranslation("ru"),
  ro,
  ar,
};

export const appLocales = [
  "en",
  "de",
  "es",
  "fr",
  "it",
  "he",
  "tr",
  "pt",
  "zh",
  "uk",
  "vi",
  "sr",
  "hr",
  "pl",
  "cs",
  "sq",
  "el",
  "ru",
  "ro",
  "ar",
]; // Position is important!

/**
 *
 * @type {{en: string, de: string, es: string, fr: string, it: string, he: string, tr: string, pt: string, zh: string, uk: string, vi: string, sr: string, hr: string, pl: string, cs: string, sq: string, el: string, ru: string, ro: string, ar: string}}
 */
export const appLanguage = {
  en: "English",
  de: "Deutsch",
  es: "Español",
  fr: "Français",
  it: "Italiano",
  he: "עִבְרִית",
  tr: "Türk",
  pt: "Portuguese",
  zh: "中文",
  uk: "Українська",
  vi: "Tiếng Việt",
  sr: "Српски",
  hr: "Hrvatski",
  pl: "Polski",
  cs: "Český",
  sq: "Shqiptare",
  el: "Ελληνικά",
  ru: "Русский",
  ro: "Romanian",
  ar: "العربية",
};

export const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(DEFAULT_LOCALE, translation[DEFAULT_LOCALE])
      : {};
  return Object.keys(messages).reduce((formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE
        ? defaultFormattedMessages[key]
        : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  }, {});
};

export const translationMessages = {
  en: formatTranslationMessages("en", translation.en),
  de: formatTranslationMessages("de", translation.de),
  es: formatTranslationMessages("es", translation.es),
  fr: formatTranslationMessages("fr", translation.fr),
  it: formatTranslationMessages("it", translation.it),
  he: formatTranslationMessages("he", translation.he),
  tr: formatTranslationMessages("tr", translation.tr),
  pt: formatTranslationMessages("pt", translation.pt),
  zh: formatTranslationMessages("zh", translation.zh),
  uk: formatTranslationMessages("uk", translation.uk),
  vi: formatTranslationMessages("vi", translation.vi),
  sr: formatTranslationMessages("sr", translation.sr),
  hr: formatTranslationMessages("hr", translation.hr),
  pl: formatTranslationMessages("pl", translation.pl),
  cs: formatTranslationMessages("cs", translation.cs),
  sq: formatTranslationMessages("sq", translation.sq),
  el: formatTranslationMessages("el", translation.el),
  ru: formatTranslationMessages("ru", translation.ru),
  ro: formatTranslationMessages("ro", translation.ro),
  ar: formatTranslationMessages("ar", translation.ar),
};
